import React, { useState, useEffect, useRef, useContext, useMemo } from 'react';
import '../App.css';
import { BsArrowUp, BsArrowDown } from 'react-icons/bs';
import USERS_ICON from '../assets/icons/ComniqaiIcon-V3.0/user-icon.svg';
import { toast } from 'react-toastify';
import { getLocalStorage, getWithToken, postWithToken } from '../API/Api';
import { useNavigate } from 'react-router-dom';
import CONVERSATIONS_ICON from '../assets/icons/ComniqaiIcon-V3.0/conversations-icon.svg';
import CONTACT_ICON from '../assets/icons/ComniqaiIcon-V3.0/new-user-icon.svg';
import CALENDAR_ICON from '../assets/icons/ComniqaiIcon-V3.0/calendar-icon.svg';
import DASHBOARD_ICON from '../assets/icons/ComniqaiIcon-V3.0/analytics-icon.svg';
import ACTIVITY_ICON from '../assets/icons/ComniqaiIcon-V3.0/recent-activity-icon.svg';
import GROWTH_ICON from '../assets/icons/ComniqaiIcon-V3.0/growth-icon.svg';
import CLOCK_ICON from '../assets/icons/ComniqaiIcon-V3.0/clock-icon.svg';
import NEW_USER_ICON from '../assets/icons/ComniqaiIcon-V3.0/new-user-icon.svg';
import Loader from '../components/Loader';
import 'react-datepicker/dist/react-datepicker.css';
import moment from 'moment';
import ConversionRateChart from './charts/ConversionRateChart';
import TrafficSourceChart from './charts/TrafficSourceChart';
import MessageAnalyticsChart from './charts/MessageAnalyticsChart';
import ContactsGrowthChart from './charts/ContactsGrowthChart';
import AvgSessionChart from './charts/AvgSessionChart';
import TotalUserChart from './charts/TotalUserChart';
import NewUserChart from './charts/NewUserChart';
import { getPlanLevel, PLAN_LEVELS } from '../API/Constant';
import SubContext from '../contexts/SubContext';
import LockedCard from '../components/LockedCard';

const formatDate = (createdAt) => {
  const now = new Date();
  const date = new Date(createdAt);

  if (isSameDay(now, date)) {
    return 'Today';
  } else if (isYesterday(now, date)) {
    return 'Yesterday';
  } else {
    return moment(date).format('DD-MM-YYYY');
  }

  function isSameDay(d1, d2) {
    return d1.getFullYear() === d2.getFullYear() && d1.getMonth() === d2.getMonth() && d1.getDate() === d2.getDate();
  }

  function isYesterday(d1, d2) {
    const yesterday = new Date(d1);
    yesterday.setDate(d1.getDate() - 1);
    return isSameDay(yesterday, d2);
  }
};

const DashboardPerformance = () => {
  const Navigate = useNavigate();
  const [loader, setLoader] = useState(true);
  const [dashData, setDashData] = useState('');
  const [startDate, setStartDate] = useState(null);
  const [endDate, setEndDate] = useState(null);
  const [leadData, setLeadData] = useState([]);
  const subsFlag = useContext(SubContext);

  const subscriptionInfo = subsFlag?.subscriptionFlag?.user?.subscription ?? null;
  const subscriptionName = subscriptionInfo?.name ?? 'Free';
  const planLevel = useMemo(() => getPlanLevel(subscriptionName), [subscriptionName]);

  let newStartDate = startDate != null ? moment(startDate).format('YYYY-MM-DD') : null;
  let newEndDate = endDate != null ? moment(endDate).format('YYYY-MM-DD') : null;

  useEffect(() => {
    let token = getLocalStorage('apiToken');
    if (token) {
      setLoader(false);
      getLeadDetails(JSON.parse(token));
      getDashboardData(JSON.parse(token));
    } else {
      Navigate('/login');
    }
  }, [startDate, endDate]);

  const getDashboardData = (token) => {
    let body = {
      filter: { start: newStartDate, end: newEndDate },
    };
    postWithToken('DashboardAPI', token, body)
      .then((response) => {
        if (response.status === 200) {
          setDashData(response.data);
        } else {
          toast.error(response.message);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const getLeadDetails = (token) => {
    setLoader(true);
    getWithToken('Lead_ListAPI', token)
      .then((response) => {
        if (response.status === 200) {
          setLeadData(response?.data);
        }
      })
      .catch((error) => {
        toast.error('Something went wrong');
      })
      .finally(() => {
        setLoader(false);
      });
  };

  const startDateRef = useRef(null);
  const endDateRef = useRef(null);
  const handleCalendarIconClick = (data) => {
    if (data === 'startDateIcon') {
      startDateRef.current.setFocus();
    } else {
      endDateRef.current.setFocus();
    }
  };

  return (
    <>
      {loader ? (
        <div className='loader-center'>
          <Loader />
        </div>
      ) : (
        <>
          <div className='dashboard-performance-card '>
            <div className='row m-0 mt-2 mb-4 ps-md-5 ps-sm-4 ps-4 pe-md-5 pe-sm-4 pe-4 '>
              <div className='col-12'>
                <div className='analytics-header d-flex justify-content-between align-items-center'>
                  <div>
                    <h6 className='mb-0 outfit-bold text-white d-flex align-items-center'>
                      <img src={DASHBOARD_ICON} alt='dashboard-icon' className='me-2' /> Analytics Dashboard
                    </h6>
                    <p className='outfit-regular mb-0'>Track your performance and user engagement metrics</p>
                  </div>
                </div>
              </div>
            </div>
            <div className='row m-0 pt-2 px-xl-5 px-lg-5 px-md-5 px-sm-4 px-xs-4 px-4 mb-4 d-flex align-items-stretch'>
              <div className='row mx-auto p-0'>
                <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-4'>
                  <div className='custom-hover'>
                    <div className='card'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={USERS_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>Total Users</p>
                        </div>
                      </div>
                      <div className='dashboard-count'>
                        <h4 className='outfit-bold mb-0'>{dashData?.total_users?.total_users_current_month?.toLocaleString() || 0}</h4>
                      </div>
                      <TotalUserChart data={dashData?.total_users} />
                      <div className='card-footer mt-auto pt-0'>
                        <p className='text-green outfit-regular mb-0'>
                          <span className={`text-green arrow-position ${dashData?.total_users?.percent_change_since_last_month >= 0 ? '' : 'text-red'}`}>
                            {dashData?.total_users?.percent_change_since_last_month}%{dashData?.total_users?.percent_change_since_last_month >= 0 ? <BsArrowUp /> : <BsArrowDown />}
                          </span>
                          &nbsp; Since last month
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
                <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-4'>
                  <LockedCard requiredLevel={PLAN_LEVELS.Scale} planLevel={planLevel}>
                    <div className='custom-hover'>
                      <div className='card'>
                        <div className='card-header'>
                          <div className='d-flex align-items-center'>
                            <div className='db-icons-fr'>
                              <img src={CONVERSATIONS_ICON} className='img-fluid' alt='users-icon' />
                            </div>
                            <p className='outfit-medium ms-2 mb-0'>Conversion Rate</p>
                          </div>
                        </div>
                        <div className='dashboard-count'>
                          <h4 className='outfit-bold mb-0'>{dashData?.conversion_rate?.total_percentage_current_month?.toLocaleString() || 0}%</h4>
                        </div>
                        <ConversionRateChart data={dashData?.conversion_rate} />
                        <div className='card-footer mt-auto pt-0'>
                          <p className='text-green outfit-regular mb-0'>
                            <span className={`text-green arrow-position ${dashData?.conversion_rate?.change_from_last_month >= 0 ? '' : 'text-red'}`}>
                              {dashData?.conversion_rate?.change_from_last_month || 0}%{dashData?.conversion_rate?.change_from_last_month >= 0 ? <BsArrowUp /> : <BsArrowDown />}
                            </span>
                            &nbsp; Since last month
                          </p>
                        </div>
                      </div>
                    </div>
                  </LockedCard>
                </div>
                <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-4'>
                  <LockedCard requiredLevel={PLAN_LEVELS.Scale} planLevel={planLevel}>
                    <div className='custom-hover'>
                      <div className='card'>
                        <div className='card-header'>
                          <div className='d-flex align-items-center'>
                            <div className='db-icons-fr'>
                              <img src={CLOCK_ICON} className='img-fluid' alt='users-icon' />
                            </div>
                            <p className='outfit-medium ms-2 mb-0'>Avg. Session</p>
                          </div>
                        </div>
                        <div className='dashboard-count'>
                          <h4 className='outfit-bold mb-0'>{dashData?.avg_session?.total_average_time_current_month?.toLocaleString() || 0}</h4>
                        </div>
                        <AvgSessionChart data={dashData?.avg_session} />
                        <div className='card-footer mt-auto pt-0'>
                          <p className='text-green outfit-regular mb-0'>
                            <span className={`text-green arrow-position ${0 >= 0 ? '' : 'text-red'}`}>
                              {0}%{0 >= 0 ? <BsArrowUp /> : <BsArrowDown />}
                            </span>
                            &nbsp; Since last month
                          </p>
                        </div>
                      </div>
                    </div>
                  </LockedCard>
                </div>
                <div className='col-xxl-3 col-xl-3 col-lg-3 col-md-12 col-sm-12 col-xs-12 mb-4'>
                  <div className='custom-hover'>
                    <div className='card'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={NEW_USER_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>New Users</p>
                        </div>
                      </div>
                      <div className='dashboard-count'>
                        <h4 className='outfit-bold mb-0'>{dashData?.new_users?.total_users_current_week?.toLocaleString()}</h4>
                      </div>
                      <NewUserChart data={dashData?.new_users} />
                      <div className='card-footer mt-auto pt-0'>
                        <p className='text-green outfit-regular mb-0'>
                          <span className={`text-green arrow-position ${dashData?.new_users?.percent_change_since_last_month >= 0 ? '' : 'text-red'}`}>
                            {dashData?.new_users?.percent_change_since_last_month}%{dashData?.new_users?.percent_change_since_last_month >= 0 ? <BsArrowUp /> : <BsArrowDown />}
                          </span>
                          &nbsp; Since last month
                        </p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
              <div className='row mb-4 mx-auto p-0'>
                <div className='col-xl-8 col-lg-8 col-sm-12 d-flex'>
                  <LockedCard requiredLevel={PLAN_LEVELS.Scale} planLevel={planLevel}>
                    <div className='custom-hover charts-card w-100 h-100'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={CONVERSATIONS_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>Message Analytics</p>
                        </div>
                        <span className='outfit-regular text-muted font14'>Messages sent and received over time</span>
                      </div>
                      <MessageAnalyticsChart data={dashData?.message_analytics} />
                    </div>
                  </LockedCard>
                </div>
                <div className='col-xl-4 col-lg-4 col-sm-12 d-flex'>
                  <LockedCard requiredLevel={PLAN_LEVELS.Scale} planLevel={planLevel}>
                    <div className='custom-hover charts-card w-100 h-100'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={ACTIVITY_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>Recent Activities</p>
                        </div>
                        <span className='outfit-regular text-muted font14'>User actions in real-time</span>
                      </div>
                      <div className='dashbord-table-container p-3'>
                        <table className='table user-table'>
                          <thead>
                            <tr>
                              <th>Name</th>
                              <th>Email</th>
                              <th>Date</th>
                            </tr>
                          </thead>
                          <tbody>
                            {leadData?.length > 0 ? (
                              leadData.slice(0, 5).map((lead, index) => (
                                <tr key={index}>
                                  <td>
                                    <span>{lead?.name || '-'}</span>
                                  </td>
                                  <td>{lead?.email || '-'}</td>
                                  <td>
                                    <span className='action-time'>{formatDate(lead?.createdAt) || '-'}</span>
                                  </td>
                                </tr>
                              ))
                            ) : (
                              <tr>
                                <td colSpan='3' className='text-center text-muted py-3'>
                                  No data found
                                </td>
                              </tr>
                            )}
                          </tbody>
                        </table>
                        {leadData.length > 5 && (
                          <div className='text-center mt-3'>
                            <button className='outfit-medium' onClick={() => Navigate('/leads')}>
                              Show More
                            </button>
                          </div>
                        )}
                      </div>
                    </div>
                  </LockedCard>
                </div>
              </div>
              <div className='row mx-auto p-0'>
                <div className='col-xxl-6 col-xl-6 col-lg-6 col-md-12 col-sm-12 col-xs-12 mb-4'>
                  <div className='custom-hover'>
                    <div className='charts-card'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={GROWTH_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>Contacts Growth</p>
                        </div>
                        <span className='outfit-regular text-muted font14'>Monthly contacts</span>
                      </div>
                      <ContactsGrowthChart data={dashData?.contacts_growth} />
                    </div>
                  </div>
                </div>
                <div className='col-xl-6 col-lg-6 col-sm-12 mb-4'>
                  <div className='custom-hover h-100'>
                    <div className='charts-card d-flex flex-column h-100'>
                      <div className='card-header'>
                        <div className='d-flex align-items-center'>
                          <div className='db-icons-fr'>
                            <img src={CONTACT_ICON} className='img-fluid' alt='users-icon' />
                          </div>
                          <p className='outfit-medium ms-2 mb-0'>Traffic Sources</p>
                        </div>
                        <span className='outfit-regular text-muted font14'>User acquisition channels</span>
                      </div>
                      <TrafficSourceChart data={dashData?.traffic_sources} />
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </>
      )}
    </>
  );
};

export default DashboardPerformance;
